import React from "react";
import { useSelectGroupContext } from "./SelectGroup";

/**
 * @visibleName SelectGroupItem.Title
 */
const SelectGroupItemDescription = ({ children }) => {
    // eslint-disable-next-line no-unused-vars
    const _ = useSelectGroupContext();

    return <p>{children}</p>;
};

export default SelectGroupItemDescription;
